
export const nameOfTheGlobal= "__cra-envs__";